import React from 'react';

export interface TempSideBarCartCalculationLineItemProps {
	lineItemDisplayName: string;
	lineItemDescription?: string;
	lineItemPrice: string;
	lineItemSubPrice?: string;
}

export function TripBookingSummarySideBarTotal({
	lineItemDisplayName,
	lineItemDescription,
	lineItemPrice,
	lineItemSubPrice,
}: TempSideBarCartCalculationLineItemProps) {
	return (
		<div className="sidebar-summary-line-item__wrap total-line-item">
			<div className="custom-underline">
				<div className="line-item-display-name__wrap">
					<p className="line-item-display-name">{lineItemDisplayName}</p>
					<p className="line-item-description">{lineItemDescription || '\u00A0'}</p>
				</div>
				<div className="line-item-price__wrap">
					<p className="line-item-price">{lineItemPrice}</p>
					<p className="line-item-sub-price">{lineItemSubPrice || '\u00A0'}</p>
				</div>
			</div>
		</div>
	);
}
